<template>
  <usertables
    :section="'voice'"
    :title="'Voice'"
  >
  </usertables>
</template>

<script>
  import Usertables from './userTables'
  export default {
    name: 'voice',
    components: {Usertables}
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/user-class/voice.vue